export const AUTH_PRIMARY_BUTTON_CLASS =
  'h-[2.75rem] rounded-[0.625rem] border-none bg-[#3cbfbc] px-[1.5rem] text-[1rem] font-medium text-gray-900 hover:!bg-[#35b2af]'

export const AUTH_PRIMARY_BUTTON_CLASS_LARGE =
  'h-[54px] w-full rounded-xl border-none bg-[#3cbfbc] text-[26px] font-medium text-gray-900 hover:!bg-[#35b2af]'
